import { render, staticRenderFns } from "./EbookHome.vue?vue&type=template&id=b0da52aa&scoped=true&"
import script from "./EbookHome.vue?vue&type=script&lang=js&"
export * from "./EbookHome.vue?vue&type=script&lang=js&"
import style0 from "./EbookHome.vue?vue&type=style&index=0&id=b0da52aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0da52aa",
  null
  
)

export default component.exports